import React, { useEffect, useState } from 'react';
import { fetchMilestones, saveMilestones } from './api';

const QUARTERS = [
  { id: 'q1', label: 'Quarter 1' },
  { id: 'q2', label: 'Quarter 2' },
  { id: 'q3', label: 'Quarter 3' },
  { id: 'q4', label: 'Quarter 4' },
];

// Her "four checkpoints — if a term ends and one of these hasn't happened,
// that's the signal to cut something rather than push harder." Owner-
// editable, not derived like Attendance/Coverage/Trends.
export default function MilestonesTab({ familyData }) {
  const [milestones, setMilestones] = useState(undefined);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!familyData?.id) return;
    fetchMilestones(familyData.id).then(m => setMilestones(m || { q1: [], q2: [], q3: [], q4: [] }));
  }, [familyData?.id]);

  if (milestones === undefined) return <p className="settings-note">Loading…</p>;

  function updateItem(q, i, text) {
    setMilestones(m => ({ ...m, [q]: m[q].map((item, idx) => (idx === i ? { ...item, text } : item)) }));
  }
  function toggleItem(q, i) {
    setMilestones(m => ({ ...m, [q]: m[q].map((item, idx) => (idx === i ? { ...item, done: !item.done } : item)) }));
  }
  function addItem(q) {
    setMilestones(m => ({ ...m, [q]: [...m[q], { text: '', done: false }] }));
  }
  function removeItem(q, i) {
    setMilestones(m => ({ ...m, [q]: m[q].filter((_, idx) => idx !== i) }));
  }

  async function save() {
    if (!familyData?.id) return;
    setSaving(true);
    try {
      await saveMilestones(familyData.id, milestones);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      {QUARTERS.map(q => (
        <div key={q.id} style={{ marginBottom: 16 }}>
          <div className="form-label" style={{ marginTop: 0 }}>{q.label}</div>
          {(milestones[q.id] || []).map((item, i) => (
            <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 4 }}>
              <input type="checkbox" checked={!!item.done} onChange={() => toggleItem(q.id, i)} />
              <input className="input" value={item.text} onChange={e => updateItem(q.id, i, e.target.value)} />
              <button className="btn btn--ghost btn--small" onClick={() => removeItem(q.id, i)}>✕</button>
            </div>
          ))}
          <button className="btn btn--ghost btn--small" onClick={() => addItem(q.id)}>+ Add checkpoint</button>
        </div>
      ))}
      <button className="btn btn--primary" disabled={saving} onClick={save}>
        {saving ? 'Saving…' : 'Save milestones'}
      </button>
    </div>
  );
}
